import { Map } from "../Types/Map";
import { AxAfterInit } from "./AxAfterInit";
import { AxInit, ModuleName } from "./AxInit";
import { AxReloadable } from "./AxReloadable";

@ModuleName("AxLoad")
export class AxLoad {
    static availableProviders: Map<any> = new Map<object>();
    static loadedModules: Map<any> = new Map<object>();

    static GetModule<T>(name: string): T {
        return AxLoad.loadedModules.get(name) as T;
    }

    static GetModuleWithoutType(name: string): object {
        return AxLoad.loadedModules.get(name);
    }

    static ReloadModule(name: string, init?: any, alias?: string, callLoaded: boolean = true) {
        let moduleInstance = this.GetModule<AxReloadable>(name);

        if (moduleInstance != null) {
            moduleInstance.AxReload(init);
            console.info(`%cAxLoad::ReloadModule reloaded Module %c${name}`, "color: #ff8034", "color: #389AA4");
        } else {
            this.LoadModule(name, init, alias, callLoaded);
        }
    }

    static LoadModule(name: string, init?: any, alias?: string, callLoaded: boolean = true) {
        $(() => {
            if (alias == null) {
                alias = name;
            }

            if (typeof this.availableProviders[name] != 'undefined') {
                let module: AxInit = new this.availableProviders[name];
                AxLoad.loadedModules.add(alias, module);
                module.AxInit(init);
                console.info(`%cAxLoad::LoadModule loaded Module %c${name}`, "color: #ff8034", "color: #389AA4");
                if (callLoaded && AxLoad.IsLoadAfterInit(module)) {
                    (<AxAfterInit>module).AxAfterInit;
                }
            } else {
                console.error(`AxLoad::LoadModule unknown Module ${name}`);
            }
        });
        return Promise.resolve();
    }

    static LoadModules(modules: ModuleLoad[], timeout: number = 1000) {
        for (let module of modules) {
            AxLoad.LoadModule(module.name, module.initData, module.alias, false);
        }

        setTimeout(function () {
            for (let module of modules) {
                let tmp: any = AxLoad.GetModule<AxInit>(module.alias || module.name);

                if (AxLoad.IsLoadAfterInit(tmp)) {
                    tmp.AxAfterInit();
                }
            }
        }, timeout);
    }

    static IsLoadAfterInit(module: AxInit | AxAfterInit): module is AxAfterInit {
        return module !== undefined && (<AxAfterInit>module).AxAfterInit !== undefined;
    }
}

interface ModuleLoad {
    name: string;
    initData: any;
    alias?: string;
}